module.exports = __webpack_public_path__ + "static/media/user-avatar.51388213.svg";